import * as React from 'react';
import { PropertyFaq } from '../../api/Property';

interface Props {
    faq: PropertyFaq;
}

const FaqIndividualDisplay = (props: Props) => {
    return (
        <article>
            <div className="faq-question-text-display">{props.faq.questionText}</div>
            <div className="faq-answer-text-display">{props.faq.answerText}</div>
        </article>
    );
};

export default FaqIndividualDisplay;



// WEBPACK FOOTER //
// ./src/components/pages/FaqIndividualDisplay.tsx